import axios from "axios";
const {REACT_APP_PARAMS_MODULE_METIER,REACT_APP_PARAMS_CESU_MULTI} = process.env;

export class ParamModuleService {

    getParamByCodeCas(val) {
        return axios.get(REACT_APP_PARAMS_MODULE_METIER + "?codeCas=" + val);
    }

    getParamCesuMulti() {
        return axios.get(REACT_APP_PARAMS_CESU_MULTI);
    }

}
